module.exports = __webpack_public_path__ + "static/media/superai_text_lg.76ad4bf6.png";